<template>
  <v-app-bar :elevation="4" app v-if="!isFirstLogin" class="pl-0" color="black">
    <v-toolbar-title class="text-no-wrap flex-0-0 mr-2">
      <span  class="v-step-0 cursor-pointer" v-if="me && me.privilege && Object.values(me.privilege).indexOf('webapp_scan_index') > -1">
        <a v-if="isMobile > 1200" :href="util.codereadrUrl()"><img src="/images/logo_30.png" alt="logo"/></a>
        <a v-if="isMobile < 1200 && isMobile > 880" :href="util.codereadrUrl()"><img src="/images/logo_cr.png" alt="logo"/></a>
        <a v-if="isMobile < 880" :href="util.codereadrUrl()"><img src="/images/logo_cr.png" alt="logo"/></a>
      </span>
      <span v-else>
        <a v-if="isMobile > 1200" :href="util.codereadrUrl()"><img src="/images/logo_30.png" alt="logo"/></a>
        <a v-if="isMobile < 1200 && isMobile > 880" :href="util.codereadrUrl()"><img src="/images/logo_cr.png" alt="logo"/></a>
        <a v-if="isMobile < 880" :href="util.codereadrUrl()"><img src="/images/logo_cr.png" alt="logo"/></a>
      </span>
    </v-toolbar-title>
    <v-tabs v-model="tab" align-with-title slider-color="yellow" v-if="me && isMobile > 880">
      <v-tab value="scan" to="/account/scans/" class="text-capitalize" v-if="me.privilege && Object.values(me.privilege).indexOf('webapp_scan_index') > -1" :hide-slider="route.meta.title !== 'Full View'">
        <span class="v-step-5 nav-title">Scans</span>
      </v-tab>
      <v-tab value="service" to="/account/services/" class="text-capitalize" v-if="me.privilege && Object.values(me.privilege).indexOf('webapp_service_index') > -1" :hide-slider="route.meta.title !== 'Services'">
        <span class="v-step-1 nav-title">Services</span>
      </v-tab>
      <v-tab value="database" to="/account/databases/" class="text-capitalize" v-if="me.privilege && Object.values(me.privilege).indexOf('webapp_database_index') > -1" :hide-slider="route.meta.title !== 'Databases'">
        <span class="v-step-2 nav-title">Databases</span>
      </v-tab>
      <v-tab value="user" to="/account/users/" class="text-capitalize" v-if="me.privilege && Object.values(me.privilege).indexOf('webapp_user_index') > -1" :hide-slider="route.meta.title !== 'Users'">
        <span class="v-step-3 nav-title">Users</span>
        <!--        <v-btn height="64px" rounded="0" class="align-self-center v-step-3 text-capitalize" size="large" @click.prevent>Users <v-icon end>mdi-menu-down</v-icon></v-btn>
                <v-menu activator="parent">
                  <v-list>
                    <v-list-item to="/account/users/">All users</v-list-item>
                    <v-list-item to="/account/admins">Admins</v-list-item>
                    <v-list-item to="/account/users/">Mobile app users</v-list-item>
                    <v-list-item to="/account/users/">Username users</v-list-item>
                    <v-list-item to="/account/users/">Unverified users</v-list-item>
                    <v-divider></v-divider>
                    <v-list-item to="/account/users/new/" prepend-icon="mdi-account-plus">Add user</v-list-item>
                  </v-list>
                </v-menu>-->
      </v-tab>
      <v-tab value="question" to="/account/questions/" class="text-capitalize" v-if="me.privilege && Object.values(me.privilege).indexOf('webapp_question_index') > -1" :hide-slider="route.meta.title !== 'Questions'">
        <span class="v-step-4 nav-title" >Questions</span>
      </v-tab>
      <v-tab value="task" to="/account/tasks/listing/instance/" class="text-capitalize" v-if="me.privilege && Object.values(me.privilege).indexOf('webapp_task_index') > -1" :hide-slider="route.meta.title !== 'Tasks'">
        <span class="v-step-6 nav-title">
          Tasks<v-badge v-if="inboxItem" dot color="yellow" class="mb-4"></v-badge>
          </span>
      </v-tab>
    </v-tabs>

    <v-spacer></v-spacer>

    <v-tabs v-model="tab" slider-color="yellow" v-if="isMobile > 1200 && isMobile > 800">
      <v-tab v-if="me && me.privilege && Object.values(me.privilege).indexOf('webapp_scan_index') > -1" value="upgrade" :to="{name: 'account.plans'}" class="text-capitalize" :hide-slider="route.meta.title !== 'Plans'">
        <span class="v-step-8 nav-title">Upgrade</span>
      </v-tab>
      <v-tab value="learn" class="text-capitalize v-step-9 nav-title" v-if="me?.adminId">
        <a  v-if="isMobile > 1200" class="text-decoration-none text-white" href="https://www.codereadr.com/learn/" target="_blank">Learn</a>
      </v-tab>
    </v-tabs>
    <v-app-bar-nav-icon v-if="isMobile < 880" @click.stop="sidebar=!sidebar" color="white" />
    <v-tabs v-model="tab" align-with-title class="d-none d-sm-flex ml-7" slider-color="yellow" v-if="!me" >
      <v-tab value="Knowledge Base" v-if="config.crFormat !== 'minimal'"><a  href="https://www.codereadr.com/learn/" class="link" target="_blank">Knowledge Base</a></v-tab>
      <v-tab value="Create Account" v-if="config.crFormat !== 'minimal'"><v-btn color="yellow" variant="flat" href="/registration/free/" target="_self">Create Account</v-btn></v-tab>
      <v-tab value="home"><v-btn href="/" target="_self" variant="flat" color="gray"> Home </v-btn></v-tab>
      <v-tab value="signIn"><v-btn href="/signin" target="_self" variant="flat" color="gray"> Sign In </v-btn></v-tab>
    </v-tabs>

    <v-menu v-if="me && me.username && isMobile > 880" class="menu_right" transition="slide-y-transition">
      <template v-slot:activator="{ props }">
        <v-tabs v-model="tab" slider-color="yellow" :hide-slider="route.path === '/account/settings/'">
          <v-tab value="account" v-bind="props" class="text-capitalize">
            <span class="v-step-7 nav-title">Account <v-icon icon="mdi-menu-down" /></span>
          </v-tab>
        </v-tabs>
      </template>
      <v-list>
        <v-list-item v-if="me && me.privilege && me.multiAccount && Object.values(me.privilege).indexOf('webapp_scan_index') > -1">
          <span class="text-h6 text-grey-darken-2">Profile</span>
          <v-list-item-title><v-icon icon="mdi-account-circle" variant="filled" /> &nbsp <b @click="router.push({ name: 'account.userprofile', query: {} })" class="cursor-pointer text-decoration-underline">{{me.username}}</b></v-list-item-title>
        </v-list-item>
        <v-list-item v-else-if="me && me.privilege && Object.values(me.privilege).indexOf('webapp_scan_index') > -1">
          <v-list-item-title><v-icon icon="mdi-account" /> &nbsp <b @click="router.push({ name: 'account.userprofile', query: {} })" class="cursor-pointer text-decoration-underline">{{me.username}}</b></v-list-item-title>
        </v-list-item>
        <v-list-item v-else>
          <v-list-item-title><v-icon icon="mdi-account" /> &nbsp <b>{{me.username}}</b></v-list-item-title>
        </v-list-item>
        <v-divider />
        <v-list-item :to="{name: 'account.userprofile'}" v-if="me">
          <span class="text-h6 text-grey-darken-2">Company</span>
          <v-list-item-title><v-icon icon="mdi-domain" /> &nbsp {{ me.companyName }}</v-list-item-title>
        </v-list-item>
        <v-list-item v-if="me && !me.isSsoEnabled" @click="handleAddCompany">
          <v-list-item-title><v-icon icon="mdi-office-building-plus" /> &nbsp Add Company</v-list-item-title>
        </v-list-item>
        <v-list-item :to="{name: 'security.select-company' }" v-if="me && me.multiAccount && !me.isSsoEnabled">
          <v-list-item-title><v-icon icon="mdi-swap-horizontal" /> &nbsp Switch Company</v-list-item-title>
        </v-list-item>
        <v-divider v-if="me.multiAccount" />
        <!--        <v-list-item v-if="me && me.privilege && me.multiAccount && Object.values(me.privilege).indexOf('webapp_scan_index') > -1">
                   <v-list-item-title><v-icon icon="mdi-email-mark-as-unread" /> &nbsp My Invitations</v-list-item-title>
                </v-list-item>-->
        <v-list-item :to="{name: 'account.user.create'}" v-if="me && me.privilege && me.multiAccount && Object.values(me.privilege).indexOf('webapp_scan_index') > -1">
          <v-list-item-title><v-icon icon="mdi-account-multiple-plus" /> &nbsp Invite Your Team</v-list-item-title>
        </v-list-item>

        <v-list-item :to="{name: 'account.setting.general'}" v-if="me && me.privilege && Object.values(me.privilege).indexOf('webapp_scan_index') > -1">
          <v-list-item-title><v-icon icon="mdi-cog" /> &nbsp Settings</v-list-item-title>
        </v-list-item>
        <v-list-item :to="{name: 'account.plans'}" v-if="isMobile < 1200 && isMobile > 880 && me && me.privilege && Object.values(me.privilege).indexOf('webapp_scan_index') > -1">
          <v-list-item-title><v-icon icon="mdi-arrow-up-bold-circle-outline" /> &nbsp Upgrade</v-list-item-title>
        </v-list-item>
        <v-list-item href="https://www.codereadr.com/learn/" v-if="isMobile < 1200 && isMobile > 880">
          <v-list-item-title><v-icon icon="mdi-school" /> &nbsp Learn</v-list-item-title>
        </v-list-item>
        <v-list-item @click="againStartTour();tab=null" v-if="tours.tourMainPage.currentStep === -1 && me && me.privilege && Object.values(me.privilege).indexOf('webapp_scan_index') > -1">
          <v-list-item-title><v-icon icon="mdi-flag" /> &nbsp Start Tour</v-list-item-title>
        </v-list-item>
        <v-list-item href="https://www.codereadr.com/support-request/" target="_blank">
          <v-list-item-title><v-icon icon="mdi-face-agent" /> &nbsp Contact Us <v-icon icon="mdi-launch" size="small" style="font-size:14px;"/> </v-list-item-title>
        </v-list-item>
        <v-divider />
        <v-list-item  @click.prevent="SecurityService.signOut();tab=null" v-if="me">
          <v-list-item-title><v-icon icon="mdi-logout" /> &nbsp Sign Out</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

  </v-app-bar>

  <v-navigation-drawer v-model="sidebar" location="right" style="background: black; color: white" disable-resize-watcher>
    <v-list-item>
      <v-list-item-title class="mt-2"><a :href="util.codereadrUrl()"><img src="/images/logo_cr.png" alt="logo"/></a></v-list-item-title>
    </v-list-item>
    <v-divider class="mb-6" :thickness="3"></v-divider>

    <v-list-item link title="Scans" to="/account/scans/" v-if="me && me.privilege && Object.values(me.privilege).indexOf('webapp_scan_index') > -1"></v-list-item>
    <v-list-item link title="Services" to="/account/services/" v-if="me && me.privilege && Object.values(me.privilege).indexOf('webapp_service_index') > -1"></v-list-item>
    <v-list-item link title="Databases" to="/account/databases/" v-if="me && me.privilege && Object.values(me.privilege).indexOf('webapp_database_index') > -1"></v-list-item>
    <v-list-item link title="Users" to="/account/users/" v-if="me && me.privilege && Object.values(me.privilege).indexOf('webapp_user_index') > -1"></v-list-item>
    <v-list-item link title="Questions" to="/account/questions/" v-if="me && me.privilege && Object.values(me.privilege).indexOf('webapp_question_index') > -1"></v-list-item>
    <v-list-item link title="Tasks" to="/account/tasks/listing/instance/" v-if="me && me.privilege && Object.values(me.privilege).indexOf('webapp_task_index') > -1"></v-list-item>

    <v-divider class="my-6" :thickness="3"></v-divider>

    <v-list-item link title="Upgrade" :to="{name: 'account.plans'}" v-if="me && me.privilege && Object.values(me.privilege).indexOf('webapp_scan_index') > -1"></v-list-item>
    <v-list-item link title="Learn" href="https://www.codereadr.com/learn/"></v-list-item>

    <v-divider class="my-6" :thickness="3"></v-divider>

    <v-list-item v-if="me" link :title="me.username" subtitle="Username" :to="{name: 'account.userprofile'}" />
    <v-list-item :to="{name: 'account.userprofile'}" v-if="me && me.privilege && me.multiAccount && Object.values(me.privilege).indexOf('webapp_scan_index') > -1">
      <span class="text-h6 text-grey-darken-2">Company</span>
      <v-list-item-title>{{ me.multiAccount.companyName }}</v-list-item-title>
    </v-list-item>

    <v-list-item v-if="me && !me.isSsoEnabled" @click="handleAddCompany">
      <v-list-item-title>Add Company</v-list-item-title>
    </v-list-item>

    <v-list-item :to="{name: 'security.select-company' }" v-if="me && me.multiAccount && !me.isSsoEnabled">
      <v-list-item-title>
        Switch Company
      </v-list-item-title>
    </v-list-item>

    <v-list-item :to="{name: 'account.user.create'}" v-if="me && me.multiAccount">
      Invite Your Team
    </v-list-item>
    <v-list-item v-if="me && me.privilege && Object.values(me.privilege).indexOf('webapp_scan_index') > -1"  link title="Settings" :to="{name: 'account.setting.general'}"></v-list-item>
    <v-list-item href="https://www.codereadr.com/support-request/" target="_blank" title="Contact Us"></v-list-item>
    <v-list-item title="Sign out" v-if="me"  @click.prevent="SecurityService.signOut()"></v-list-item>
  </v-navigation-drawer>
  <v-tour name="tourMainPage" :steps="steps" id="v-tour-step" :callbacks="mainPageCallbacks" ></v-tour>
</template>

<script setup lang="ts">
import {onBeforeMount, ref, onMounted, getCurrentInstance, watch, computed} from "vue";
import {useRouter, useRoute, onBeforeRouteUpdate} from "vue-router";
import  moment from "moment";
import  FlashMessenger from "../service/FlashMessenger";
import Config from "../service/Config";
import util from "../service/UtilService";
import browserStorageService from '../service/BrowserStorageService';
import crApi from '../service/CrApi';
import axios from "axios";
import SecurityService from "../service/SecurityService";
import store from "../store/store";
import EventManager from "../service/AppEventManagerService";
import securityService from "../service/SecurityService";

const s3AuthMethod = ref([
  {id: 'pool_id', name: 'Identity Pool ID'},
  {id: 'access_key', name: 'Access Key'}
]);
const sftpAuthType = ref([
  {id: 'password', name: 'Username & Password'},
  {id: 'key', name: 'RSA Key'}
]);
const route = ref(useRoute());
const router = ref(useRouter());
const sidebar = ref(false);
const tab = ref(null);
const me = ref(null);
const v = ref('0.0.0');
const showEmailConfirmationPopup = ref(false);
const confirmText = ref('');
const showRetentionCleanupWarningModal = ref(false);
const processingNewTerms = ref(false);
const noInternetConnection = ref(false);
const latestVersion = ref(Config.version);
const taskBoxCount = ref(0);
const currentName = ref<any>('');
const websiteToken = ref(SecurityService.getToken());
const isAdminOnFreePlan = ref(false);
const isOwner = ref(null);
const currentTourStep = ref<any>(0);
const countTourStep = ref<any>(10);
const steps = ref([]);
const isFirstLogin = ref(false);
const inboxItem = ref(false);
const adminAccountId = ref('');
const username = ref(store.getters.getAdminEmail);
const signOutModal = ref(false);
declare const window: any;
const internalInstance = ref(getCurrentInstance());
const config = ref(Config);
const currentTourActive = ref(true);
const tours = ref<any>(internalInstance.value.appContext.config.globalProperties.$tours);
const securityServiceUserPromise = ref("securityService._userPromise");
const windowWidth = ref(window.innerWidth);
const mainPageCallbacks = ref({
  onPreviousStep: mainPageCustomPreviousStepCallback,
  onNextStep: mainPageCustomNextStepCallback,
  onSkip: onSkipTour,
  onFinish:onFinishTour,
});

const isMobile = computed(()=> {
  return windowWidth.value;
});

onBeforeMount(() => {
  EventManager.on('auth.signin', async ()=> {
    await load();
  });
  EventManager.on('auth.signout-pre', ()=> {
    // this.$bvModal.show('modalSignout');
    signOutModal.value = true;
  });
  EventManager.on('auth.signout-post', async ()=> {
    await checkUser();
    window.location.href = '/signin';
  });
})

onMounted(async () => {
  window.addEventListener('resize', () => {
    windowWidth.value = window.innerWidth;
  })
  if ((window.location.pathname === '/account/services/create-demo/' || window.location.pathname === '/account/pickinterests/') && route.value.query.firstLogin === "1") {
    isFirstLogin.value = true;
  }
  await load();
  await noStartTour(route.value,null);
});

onBeforeRouteUpdate (async (to,from,next) => {
  const response = await crApi.requestV2('task/inbox_item',{"website_token" : securityService.getToken()});
  inboxItem.value = response ? response.inboxHasItems : false;
  let requiresAuth = false;
  for (let r of route.value.matched) {
    if (r.meta.authenticate !== undefined) {
      requiresAuth = Boolean(r.meta.authenticate);
    }
  }
  currentName.value = to.path;
  if (requiresAuth) {
    checkEmailConfirmationSent();
  }
  await noStartTour(to,from);
  next();
});

watch(() => isMobile.value, () => {
  sidebar.value = !!(isMobile.value < 880 && sidebar.value);
})

watch(() => taskBoxCount.value, (newCount) => {
  taskBoxCount.value = newCount;
});

watch(() => securityServiceUserPromise.value, () => {
  checkUser();
}, {deep: true});

watch(() => route.value.fullPath,async (newVal,oldVal) => {
  await noStartTour(newVal,oldVal);
});

watch(() => tab.value, (newVal,oldVal) => {
  if (newVal === 'account') {
    tab.value = oldVal;
  }
})

async function load () {
  currentName.value = router.value.currentRoute.path;
  setInterval(() => {
    FlashMessenger.refresh();
  }, 500);
  store.subscribe((mutation, state) => {
    if (mutation.type === 'setAdminEmail') {
      username.value = state.adminEmail;
    }
  });
  const serviceData = await SecurityService.me();
  adminAccountId.value = serviceData ? serviceData.accountId : '';

  await checkUser();
  const versionChars = [];
  if (Config.version < 100) {
    versionChars.push(0);
  }
  for (let c of Config.version) {
    versionChars.push(c);
  }
  v.value = versionChars.join('.');

  let check = async () => {
    let ts = Math.round((new Date()).getTime() / 1000);
    const res = await axios.get('version.json?t=' + ts);
    let version = res.data;
    latestVersion.value = version.current;
    if (version.min > Config.version) {
      window.location.reload(true);
    }
  };
  await check();
  setInterval(check, 5 * 60 * 1000);

  let requiresAuth:any = false;
  for (let r of route.value.matched) {
    if (r.meta.requiresAuth !== undefined) {
      requiresAuth = r.meta.requiresAuth;
    }
  }
  if (me.value && parseInt(me.value.active) < 1 && !browserStorageService.getItem('emailConfirmationSent') && requiresAuth) {
    showEmailConfirmationPopup.value = true;
    browserStorageService.setItem('emailConfirmationSent', '1');
  }
  if(me.value){
    const pp = await crApi.requestV2('paymentplan/retrieve',{paymentPlanId: me.value.planId, "website_token" : securityService.getToken()});
    if (pp.status === 1 && pp.paymentPlan[0].textId === 'free') {
      isAdminOnFreePlan.value = true;
      /*if(me.value.adminProperty !== undefined){
          for (let p of me.value.adminProperty) {
              if (p.name === 'retentionCleanup') {
                  showRetentionCleanupWarningModal.value = !(p.value != '');
              }
          }
      }*/
    }
  }
  if (window.HubSpotConversations && me.value) {
    window.HubSpotConversations.on('conversationReady', function() {
      window.HubSpotConversations.widget.identify({
        email: me.value.username,
        name: '',
      });
    });
  }
  window.addEventListener("offline", () => {
    noInternetConnection.value = true;
  }, false);

  window.addEventListener("online", () => {
    noInternetConnection.value = false;
  }, false);


  if (window.location.pathname !== '/crapp/scan/edit/') {
    let lastReload = null;
    setInterval(async () => {
      let ts = Math.round((new Date()).getTime() / 1000);

      let reloadInterval = 2 * 60;

      if (lastReload == null || ts - lastReload >= reloadInterval) {
        lastReload = ts;
        const response = await crApi.requestV2('task/inbox_item',{"website_token" : securityService.getToken()});
        inboxItem.value = response ? response.inboxHasItems : false;
      }
    }, 1000);
  }
}

async function checkUser(){
  const response = await SecurityService.getUser();
  if (!response || response.error) {
    me.value = null;
    Config.crFormat = 'minimal';
  } else {
    me.value = response.admin[0];
    Config.crFormat = 'normal';
    if (me.value.username !== username.value) {
      store.commit('setAdminEmail', me.value.username);
    }
    isOwner.value = SecurityService.isOwner();
    const pickedInterest = me.value.pickedInterest;
    // const isDemoServiceSelected = me.value.isDemoServiceSelected;
    /*if (window.location.pathname != '/account/services/create-demo/') {
      if (isDemoServiceSelected !== undefined && isDemoServiceSelected !== '' && !parseInt(isDemoServiceSelected)) {
        window.location.href = '/account/services/create-demo/?firstLogin=1&noTour=1'
      }
    }*/

    if (window.location.pathname !=  '/pick-interest/') {
      if (pickedInterest !== undefined && pickedInterest !== '' && !parseInt(pickedInterest)) {
        window.location.href = '/pick-interest/?noTour=1&firstLogin=1';
      }
    }
  }
  checkEmailConfirmationSent();
  gAnalytic(response);
}

function checkEmailConfirmationSent() {
  let showConfirmation = false;
  if (me.value && Number(me.value.active) < 1 && !parseInt(browserStorageService.getItem('emailConfirmationSent')) && !SecurityService.getAccountUserId()) {
    showConfirmation = true;
    browserStorageService.setItem('emailConfirmationSent', '1');
  }

  if( currentName.value === '/account/firstlogin/' ){
    showEmailConfirmationPopup.value = false;
  }else{
    showEmailConfirmationPopup.value = showConfirmation;
  }
}

function hideEmailConfirmationPopup() {
  showEmailConfirmationPopup.value = false;
}

async function goToSettings() {
  // await router.value.push({name: "account.setting"});
  await router.value.push({});
}

async function sendConfirmMail(email) {
  const params = {
    "website_token" : websiteToken.value,
    "email": email
  };

  const admin = await crApi.requestV2('admin/activation_email', params)
  if (admin['status'] == 1) {
    confirmText.value = "A confirmation mail is sent to " + admin.username;
  } else {
    confirmText.value = "We are unable to process your request, kindly try again after sometime";
  }
}

/*async function acceptNewTerms() {
    if (processingNewTerms.value) {
        return;
    }
    processingNewTerms.value = true;

    const response = await crApi.requestV2('admin/update', {"website_token" : websiteToken.value, 'retention_cleanup': 1})
    if (response.status == 1) {
        processingNewTerms.value = false;
        showRetentionCleanupWarningModal.value = false;
    } else {
        await FlashMessenger.toastById(response.error._code, 'error');
        processingNewTerms.value = false;
    }
}*/

function formatTimePassed(date,format) {
  if (!date || date === undefined) {
    return null;
  }
  const dt = date.replace('T',' ');
  const res = dt.slice(0, 19);
  return moment(res).format(format);
}

function reloadNow() {
  window.location.reload(true);
}

function stepsParams() {
  return [
    {
      target: '.v-step-0',
      content: `<div class="text-left pa-2">
                        <div class="d-flex justify-space-between">
                            <h2 class="font-weight-bold">Getting Started</h2>
                            <span class="p-2 text-right">(1 of ${countTourStep.value})</span>
                        </div>
                        <div>Since it’s your first time here, let us show you around. To jump straight into configuring your own workflows (aka “Services”), simply click the “Skip tour” button below.</div>
                    </div>`,
      params: { placement: 'bottom', enableScrolling: false }
    },
    {
      target: '.v-step-1',
      content: `<div class="text-left p-2">
                        <div class="d-flex justify-space-between">
                            <h2 class="font-weight-bold">Services</h2>
                            <span class="p-2 text-right">(2 of ${countTourStep.value})</span>
                        </div>
                        <div>Here is where the services you created and optional demo services are listed. Click “Add a Service” to configure a new service. Click on the service name to edit, duplicate, or delete it.</div>
                    </div>`,
      params: { placement: 'bottom', enableScrolling: false }
    },
    {
      target: '.v-step-2',
      content: `<div class="text-left p-2">
                        <div class="d-flex justify-space-between">
                            <h2 class="font-weight-bold">Databases</h2>
                            <span class="p-2 text-right">(3 of ${countTourStep.value})</span>
                        </div>
                        <div>Services can be configured to validate (compare) scans against a database. Here is where you add your databases and can optionally generate QR codes for exporting.</div>
                    </div>`,
      params: { placement: 'bottom', enableScrolling: false }
    },
    {
      target: '.v-step-3',
      content: `<div class="text-left p-2">
                        <div class="d-flex justify-space-between">
                            <h2 class="font-weight-bold">Users</h2>
                            <span class="p-2 text-right">(4 of ${countTourStep.value})</span>
                        </div>
                        <div>Here you create app users authorized to use the mobile app to scan barcodes and collect data in the field. You can also <a href="/account/admins"><u>invite your team</u></a> and add admin users to manage your account.</div>
                    </div>`,
      params: { placement: 'bottom', enableScrolling: false }
    },
    {
      target: '.v-step-4',
      content: `<div class="text-left p-2">
                        <div class="d-flex justify-space-between">
                            <h2 class="font-weight-bold">Questions</h2>
                            <span class="p-2 text-right">(5 of ${countTourStep.value})</span>
                        </div>
                        <div>Questions are prompts presented to your mobile app users during the scanning process. Options include form fields, menu selections, GPS location, photo collect, and signature capture.</div>
                    </div>`,
      params: { placement: 'bottom', enableScrolling: false }
    },
    {
      target: '.v-step-5',
      content: `<div class="text-left p-2">
                        <div class="d-flex justify-space-between">
                            <h2 class="font-weight-bold">Scans</h2>
                            <span class="p-2 text-right">(6 of ${countTourStep.value})</span>
                        </div>
                        <div>Here you can filter, view, delete, and create export templates for exporting your scan records. Scan records can even be shared. There’s also a map view and photo grid.</div>
                    </div>`,
      params: { placement: 'bottom', enableScrolling: false }
    },
    {
      target: '.v-step-6',
      content: `<div class="text-left p-2">
                        <div class="d-flex justify-space-between">
                            <h2 class="font-weight-bold">Tasks</h2>
                            <span class="p-2 text-right">(7 of ${countTourStep.value})</span>
                        </div>
                        <div>Tasks are scheduled or on-demand actions for importing, exporting, and downloading records. Tasks help you automate the management of scans, databases, and users.</div>
                    </div>`,
      params: { placement: 'bottom', enableScrolling: false }
    },
    {
      target: '.v-step-7',
      content: `<div class="text-left p-2">
                        <div class="d-flex justify-space-between">
                            <h2 class="font-weight-bold">Settings</h2>
                            <span class="p-2 text-right">(8 of ${countTourStep.value})</span>
                        </div>
                        <div>Account settings and branding options can be edited here. Check your API usage, share links, billing, devices, and more.</div>
                    </div>`,
      params: { placement: 'bottom', enableScrolling: false }
    },
    {
      target: '.v-step-8',
      content: `<div class="text-left p-2">
                        <div class="d-flex justify-space-between">
                            <h2 class="font-weight-bold">Pricing</h2>
                            <span class="p-2 text-right">(9 of ${countTourStep.value})</span>
                        </div>
                        <div>The Free Plan allows you to test the services you’ve configured and scan with the mobile apps. Scans are limited to 50/month, but at any time you can upgrade to a paid plan when ready.</div>
                    </div>`,
      params: { placement: 'bottom', enableScrolling: false }
    },
    {
      target: '.v-step-9',
      content: `<div class="text-left p-2">
                        <div class="d-flex justify-space-between">
                            <h2 class="font-weight-bold">Support</h2>
                            <span class="p-2 text-right">(${countTourStep.value} of ${countTourStep.value})</span>
                        </div>
                        <div>Questions? Use the Knowledge Base or contact us via email or the website’s Chat Now utility (no bots!). Time to start scanning!</div>
                    </div>`,
      params: { placement: 'bottom', enableScrolling: false }
    },
  ]
}

async function againStartTour() {
  const account = await SecurityService.me();
  currentTourStep.value = 0;
  await crApi.requestV2('admin/set_tour_step', {tourName: 'TourMainPage', tourStep: currentTourStep.value, "website_token" : websiteToken.value});
  await startTour();
}

async function startTour () {
  steps.value = stepsParams();
  const account = await SecurityService.me();
  if (account) {
    if (account.role && account.role.includes('admin')) {
      countTourStep.value = 9;
      steps.value = stepsParams();
      steps.value[8] = steps.value[9];
      steps.value.length = 9;
    }
    const startTourStep = await crApi.requestV2('admin/get_tour_step',{tourName: 'TourMainPage', "website_token" : websiteToken.value});
    if (startTourStep.status === 1) {
      currentTourStep.value = parseInt(startTourStep.step);
      if (currentTourStep.value !== 999) {
        if (tours.value) {
          if (tours.value['tourMainPage']) {
            tours.value['tourMainPage'].start();
          }
        }
      }
    }
  }
  currentTourActive.value = false;
}

async function mainPageCustomPreviousStepCallback (currentStep) {
  const account = await SecurityService.me();
  currentTourStep.value = currentStep - 1;
  await crApi.requestV2('admin/set_tour_step',{tourName: 'TourMainPage', tourStep:currentTourStep.value, "website_token" : websiteToken.value});
}

async function mainPageCustomNextStepCallback (currentStep) {
  const account = await SecurityService.me();
  currentTourStep.value = currentStep + 1
  await crApi.requestV2('admin/set_tour_step',{tourName: 'TourMainPage', tourStep: currentTourStep.value, "website_token" : websiteToken.value});
}

async function onSkipTour () {
  const account = await SecurityService.me();
  currentTourStep.value = 999;
  await crApi.requestV2('admin/set_tour_step', {tourName: 'TourMainPage', tourStep: currentTourStep.value, "website_token" : websiteToken.value});
}

async function onFinishTour () {
  const account = await SecurityService.me();
  currentTourStep.value = 999;
  await crApi.requestV2('admin/set_tour_step', {tourName: 'TourMainPage', tourStep: currentTourStep.value, "website_token" : websiteToken.value});
}

async function noStartTour(to, from) {
  if ((to.query && !to.query.noTour || to.query && to.query.noTour != 1) && window.innerWidth > 880) {
    await startTour();
  }
}

async function gAnalytic(data) {
  const userAgent = navigator.userAgent.toLowerCase();
  const adminResponse = await securityService.me();
  const pickInterest = await crApi.requestV2('admin/retrieve_admin_property_value/', {
    adminId: adminResponse?.adminId,
    propertyName: "pick-interests",
    website_token: securityService.getToken()
  });
  const pickInterestValue  = pickInterest && pickInterest.status == 1 ? pickInterest.propertyValue[0].value : '';
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'user_account_details_loaded',
    user_account_details: {
      current_plan_id: data.admin[0].planId,
      picked_interest: pickInterestValue,
      first_paid_plan_id: data.admin[0].firstPaidPlanId || null,
      registration_source: data.admin[0].deviceType,
      was_demo_service_selected: data.admin[0].isDemoServiceSelected || 0
    }
  });
}

// Handle Add Company action
function handleAddCompany() {
  if (me.value && me.value.username) {
    const form = document.createElement('form');
    form.method = 'get';
    form.action = '/confirm-multi-account';

    const usernameInput = document.createElement('input');
    usernameInput.type = 'hidden';
    usernameInput.name = 'username';
    usernameInput.value = me.value.username;

    form.appendChild(usernameInput);
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
  }
}

</script>

<style scoped lang="scss">

.v-step {
  background: #f9d367!important;
  color: #000;
}

.menu_right {
  :deep(.v-overlay__content) {
    right: 0 !important;
    left: auto!important;
  }
}

.v-toolbar {
  background-color: black!important;
}
.nav-title {
  font-size:16px;
}

:deep(.v-step[data-v-da2d894c]){
  background: #f9d367!important;
  color: #000;
  top: 5px!important;
}

:deep(.v-step__button) {
  background-color:black!important;
  border: 0.05rem solid #1e1a1a!important;
}
:deep(.v-step__button:hover) {
  background-color:black!important;
  color:white!important;
}
:deep(.v-badge) {
  padding: 0px 16px 0px 5px;
}
</style>
